import {React,useReducer,useEffect} from 'react'
import {poducturl} from './Fetcher'
import Product from './Product'
import { useParams } from 'react-router-dom'
import Header from './Header'
import { Footer } from './Footer1'
import Hotdeal from './Hotdeal'
import { Bestselling } from './Bestselling'
import Nav from '../component/Nav';
import Singlegadget from './Singlegadget'

const initaistate ={
 
  loading : true,
  data : [],
  error : '',

}


const reducer = (state,action)=>{
switch(action.type){
  case 'sucess' :
    return{...state,
      loading: false ,
      data: action.payload,
      error: ''
    }
case 'error' :
  return{...state,
    loading: false ,
    data: [],
    error: action.errormessage
  }
}
}

const Categories = () => {
  const [ productdata , dispatch] = useReducer(reducer,initaistate)
  const{categoriesid} = useParams()
  useEffect(()=>{
    poducturl({ id:categoriesid, dispatch:dispatch})
  },[categoriesid])
  
  
  const rerenderproduct=()=>{
    return  productdata.data.map(data=>(
     <Singlegadget key={data.id} data={data}/>
    
    ))
  }
  rerenderproduct()
  return (
<div>
  <Nav/>
    <header>
        <div id='bg-text-container'>
<h5 style={{color:'white',textAlign:'left'}}>Best Deal online on Smart watches </h5>
<h1 style={{color:'white',textAlign:'left'}}>SMART WEARABLE. </h1>
<h5 style={{color:'white',textAlign:'left'}}>UP to 80% OFF</h5>
        </div>

        <div id='bg-image-container'>
<img src="/asset/Watch Ultra.png" alt="" />
        </div>
      </header>

  {/* <Header/> */}
  { productdata.loading ? 'loading': rerenderproduct()}  
{ productdata.error ? `Error ${ productdata.error}`  : null}

<Hotdeal/>
<Bestselling/>

{/* <div id='service-wrapper'>

<div >
<img src={`/asset/Group.png`}/>
<h6>FREE AND FAST DELIVERY</h6>
<p>Free delivery for all orders over $140</p>
</div>


<div >
<img src={`/asset/services.png`}/>
<h6>24/7 CUSTOMER SERVICE</h6>
<p>Friendly 24/7 customer support</p>
</div>

<div >
<img src={`/asset/servicess.png`}/>
<h6>MONEY BACK GUARANTEE</h6>
<p>We reurn money within 30 days</p>
</div>

</div> */}



<Footer/>

</div>
  )
}

export default Categories